import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import { ProfileTypes } from '@api/Users/User';

/**
 * Alto en px de la barra de "Ver como". El layout lo RESTA del alto disponible:
 * si no, el contenido se pasa de `100vh` y aparece scroll de página (el mismo
 * bug de `box-sizing` que ya nos mordió con el Dashboard y el tablero).
 */
export const PREVIEW_BANNER_HEIGHT = 36;

/**
 * ¿El admin está mirando el sistema como otro perfil?
 *
 * `loggedUser.profile.profile` = QUIÉN ERES (no cambia nunca).
 * `profileSelected`            = QUÉ ESTÁS VIENDO (las rutas que se montan).
 *
 * Regla única para no dejar que banner, sidebar y layout se desincronicen.
 */
export const useProfilePreview = () => {
    const { loggedUser, profileSelected } = useSelector((state: RootReducer) => state.auth);
    const isAdmin = loggedUser?.profile.profile === ProfileTypes.Admin;

    return {
        isAdmin,
        isPreviewing: isAdmin && !!profileSelected && profileSelected !== ProfileTypes.Admin,
        previewProfile: profileSelected
    };
};
